import type { ReactNode } from "react";

interface FormInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "email" | "password";
  icon?: ReactNode;
  hint?: string;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
}

export function FormInput({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  icon,
  hint,
  required = false,
  maxLength,
  disabled = false,
  className = "",
  inputClassName = "",
}: FormInputProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <label className="block text-sm font-medium text-slate-900">
        {label}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">
            {icon}
          </div>
        )}
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          disabled={disabled}
          className={`w-full border border-slate-200 rounded-xl py-3 ${
            icon ? "pl-11" : "pl-4"
          } pr-4 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth bg-white ${inputClassName}`}
        />
      </div>
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

